import React, {useEffect, useState} from 'react'
import {getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileAdditionalInformationForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity, updateCandidate, setUpdateCandidate}) => {

    const [entity, setEntity] = useState(entityTemp)

    const [referralOrigin, setReferralOrigin] = useState([])

    const [checkedThreeShiftsYes, setCheckedThreeShiftsYes] = useState(false)
    const [checkedThreeShiftsNo, setCheckedThreeShiftsNo] = useState(false)
    const [checkedTwoShiftsYes, setCheckedTwoShiftsYes] = useState(false)
    const [checkedTwoShiftsNo, setCheckedTwoShiftsNo] = useState(false)

    const checkedThreeShifts = () => {
        if(entityTemp.entity){
            if(entityTemp.entity.workInThreeShifts === null) {
                setCheckedThreeShiftsYes(false)
                setCheckedThreeShiftsNo(false)
            } else if (entityTemp.entity.workInThreeShifts === true){
                setCheckedThreeShiftsYes(true)
                setCheckedThreeShiftsNo(false)
            } else if(entityTemp.entity.workInThreeShifts === false){
                setCheckedThreeShiftsYes(false)
                setCheckedThreeShiftsNo(true)
            }
        }

    }

    const checkedTwoShifts = () => {
        if(entityTemp.entity){
            if(entityTemp.entity.workInTwoShifts === null) {
                setCheckedTwoShiftsYes(false)
                setCheckedTwoShiftsNo(false)
            } else if (entityTemp.entity.workInTwoShifts === true){
                setCheckedTwoShiftsYes(true)
                setCheckedTwoShiftsNo(false)
            } else if(entityTemp.entity.workInTwoShifts === false){
                setCheckedTwoShiftsYes(false)
                setCheckedTwoShiftsNo(true)
            }
        }

    }

    const checkSalaryValue = (e) => {
        const re = /^[0-9\b]+$/
        if (!re.test(e.key)) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        getResource('candidates/get_logged_user_candidate').then(data => {
            setEntity(data.data);
        })
        getResource('referral_origins/get_active').then((data) => {
            console.log(data.data)
            setReferralOrigin(data.data)
            checkedThreeShifts()
            checkedTwoShifts()
            console.log(entity)
        })
    },[])


    return (

            <div className="background-form col-12 p-0">
                {(entity && entity.id) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                            <div className="col-lg-10 offset-lg-1 personal-info-form-container">
                                   <div className="col-lg-8 d-flex align-items-center">
                                       <p className="lightBlue">Очекувана нето плата</p>
                                         <input className="w-50"
                                                type="number"
                                                value={entity.expectedSalary}
                                                onKeyPress={(e) => checkSalaryValue(e)}
                                                onChange={(e)=>{
                                                        setEntity({...entity, expectedSalary: e.target.value})
                                                }}
                                         />
                                       <span>&euro;</span>
                                   </div>

                                <div className="col-12 d-flex align-items-center flex-wrap flex-lg-nowrap">
                                    <p className="lightBlue shiftsTitle">
                                        Дали ви одговара работа во три смени?</p>
                                        <input type="radio" id="da-tri" name="shifts-tri" value="da-tri"
                                               checked={checkedThreeShiftsYes}
                                               onClick={(e)=> {
                                                   setEntity({...entity, workInThreeShifts: true})
                                                   setCheckedThreeShiftsYes(true)
                                                   setCheckedThreeShiftsNo(false)
                                               }}/>
                                        <label className="lightBlue" htmlFor="da-tri">Да</label>
                                        <input type="radio" id="ne-tri" name="shifts-tri" value="ne-tri"
                                               checked={checkedThreeShiftsNo}
                                               onClick={(e) => {
                                                   setEntity({...entity, workInThreeShifts: false})
                                                   setCheckedThreeShiftsYes(false)
                                                   setCheckedThreeShiftsNo(true)
                                               }}/>
                                        <label className="lightBlue" htmlFor="ne-tri">Не</label>
                                </div>
                                <div className="col-12 d-flex align-items-center flex-wrap flex-lg-nowrap">
                                    <p className="lightBlue shiftsTitle">
                                        Дали ви одговара работа во две смени?</p>

                                        <input type="radio" id="da-dve" name="shifts-dve" value="da-dve"
                                               checked={checkedTwoShiftsYes}
                                               onClick={(e)=>{
                                                   setEntity({...entity, workInTwoShifts: true})
                                                   setCheckedTwoShiftsYes(true)
                                                   setCheckedTwoShiftsNo(false)
                                               }}/>
                                        <label className="lightBlue" htmlFor="da-dve">Да</label>
                                        <input type="radio" id="ne-dve" name="shifts-dve" value="ne-dve"
                                               checked={checkedTwoShiftsNo}
                                               onClick={(e) => {
                                                   setEntity({...entity, workInTwoShifts: false})
                                                   setCheckedTwoShiftsYes(false)
                                                   setCheckedTwoShiftsNo(true)
                                               }}/>
                                        <label className="lightBlue" htmlFor="ne-dve">Не</label>
                                </div>
                                <div className="profile-form-edit">
                                    <label className="lightBlue">Хоби и интереси</label>
                                    <textarea cols="60"
                                              value={entity.hobbies}
                                              onChange={(e)=>
                                                  setEntity({...entity, hobbies: e.target.value})}
                                    />
                                </div>
                                <div className="profile-form-edit">
                                    <label className="lightBlue">Опиши се себеси</label>
                                    <textarea cols="60"
                                              value={entity.selfDescription}
                                              onChange={(e)=>
                                                  setEntity({...entity, selfDescription: e.target.value})}
                                    />
                                </div>
                                <div className="profile-form-edit">
                                    <label className="lightBlue">Останато</label>
                                    <textarea cols="60"
                                              value={entity.otherInformation}
                                              onChange={(e)=>
                                                  setEntity({...entity, otherInformation: e.target.value})}
                                    />
                                </div>

                                {(referralOrigin && referralOrigin.length > 0) &&
                                    (
                                        <>
                                            <Combo
                                                tooltipText="Како дознавте за нас"
                                                comboClass="combo-form"
                                                placeholder="Како дознавте за нас"
                                                entity={(entity.referralOrigin) && entity.referralOrigin.name}
                                                setEntity={setEntity}
                                                onChange={(e) => {
                                                    let chosenReferralOrigin = {};
                                                    chosenReferralOrigin.id = e.target.value;
                                                    setEntity({ ...entity, referralOrigin: chosenReferralOrigin})
                                                }}
                                                onClear={() => setEntity({...entity, referralOrigin:null})}
                                                array={referralOrigin}/></>)}

                                <div className="d-flex justify-content-between">
                                    <div
                                        className="btn-form"
                                        onClick={()=> {
                                            setAddEntity(false)
                                            setEntityTemp(entityTemp.entity)
                                        }}
                                    >Затвори</div>
                                    <div
                                        className="btn-form"
                                        onClick={(e) => {
                                            updateResource('candidates', entity)
                                                .then((data) => {
                                                    setEntityTemp(data.data);
                                                    setAddEntity(false);
                                                    setUpdateEntity(!updateEntity)
                                                    setUpdateCandidate(!updateCandidate)
                                                })
                                        }}
                                    >Зачувај</div>
                                </div>
                            </div>
            </>
            )
                }
        </div>
    )
}